import { useState } from 'react'
import { CATEGORIES, COUNTRIES, SORT_OPTIONS, STATUS_FILTERS } from '../data/constants.js'

// Barra de filtros para el listado de lotes (requisito 3).
// "Controlada": recibe valores actuales y un onChange con el nuevo objeto.
// Incluye: texto, estado, categoría, país, casa de subastas, precio mín/máx,
// con/sin precio mínimo, fecha de cierre y ordenación.
export default function Filters({ filters, onChange }) {
  const [q, setQ] = useState(filters.q || '')

  const update = (patch) => onChange({ ...filters, ...patch })

  const submitSearch = (e) => {
    e.preventDefault()
    onChange({ ...filters, q, page: 1 })
  }

  return (
    <div className="filters">
      <form className="filters-search" onSubmit={submitSearch} role="search">
        <input
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Suche: z. B. Stapler, Bagger, CNC…"
          aria-label="Suchbegriff"
        />
        <button type="submit" className="btn btn-primary">Suchen</button>
      </form>

      <div className="filters-grid">
        <label className="filters-field">
          <span>Status</span>
          <select value={filters.status || 'active'} onChange={(e) => update({ status: e.target.value, page: 1 })}>
            {STATUS_FILTERS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </label>

        <label className="filters-field">
          <span>Kategorie</span>
          <select value={filters.category || ''} onChange={(e) => update({ category: e.target.value, page: 1 })}>
            <option value="">Alle Kategorien</option>
            {CATEGORIES.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
          </select>
        </label>

        <label className="filters-field">
          <span>Land</span>
          <select value={filters.country || ''} onChange={(e) => update({ country: e.target.value, page: 1 })}>
            <option value="">Alle Länder</option>
            {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.label}</option>)}
          </select>
        </label>

        <label className="filters-field">
          <span>Auktionshaus</span>
          <select value={filters.house || ''} onChange={(e) => update({ house: e.target.value, page: 1 })}>
            <option value="">Alle Häuser</option>
            <option value="troostwijk">Troostwijk Auctions</option>
          </select>
        </label>

        <label className="filters-field">
          <span>Preis von (EUR)</span>
          <input
            type="number" min="0" placeholder="z. B. 1000"
            value={filters.min_price || ''}
            onChange={(e) => update({ min_price: e.target.value, page: 1 })}
          />
        </label>

        <label className="filters-field">
          <span>Preis bis (EUR)</span>
          <input
            type="number" min="0" placeholder="z. B. 5000"
            value={filters.max_price || ''}
            onChange={(e) => update({ max_price: e.target.value, page: 1 })}
          />
        </label>

        <label className="filters-field">
          <span>Preis</span>
          <select value={filters.with_price || ''} onChange={(e) => update({ with_price: e.target.value, page: 1 })}>
            <option value="">Alle</option>
            <option value="with">Nur mit Gebot</option>
            <option value="without">Noch ohne Gebot</option>
          </select>
        </label>

        <label className="filters-field">
          <span>Endet vor (Datum)</span>
          <input
            type="date"
            value={filters.closes_before || ''}
            onChange={(e) => update({ closes_before: e.target.value, page: 1 })}
          />
        </label>

        <label className="filters-field">
          <span>Endet nach (Datum)</span>
          <input
            type="date"
            value={filters.closes_after || ''}
            onChange={(e) => update({ closes_after: e.target.value, page: 1 })}
          />
        </label>

        <label className="filters-field">
          <span>Sortierung</span>
          <select value={filters.order || 'closing'} onChange={(e) => update({ order: e.target.value, page: 1 })}>
            {SORT_OPTIONS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </label>
      </div>
    </div>
  )
}
